// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__nJmDh","cardTop":"ProductCard_cardTop__kAawC","fav":"ProductCard_fav__KcZ5Q","active":"ProductCard_active__bON1Q","cardInfo":"ProductCard_cardInfo__9x69i"};